import { Injectable } from '@angular/core';

import { ApplyWorkflowNodePayload } from '@blaze-runtime/engine-data-access';
import { assertNextNodeIsNotSelf } from '@blaze-runtime/workflow-domain';
import { getWorkflowNodeById } from '@blaze-shared/workflow-domain';

import { NodeExecutionResult } from './node-execution-result';

@Injectable({ providedIn: 'root' })
export class NodeExecutionResultService {
  /**
   * Computes next node payload from node execution result.
   */
  getNextNodePayloadFromResult(
    nodePayload: ApplyWorkflowNodePayload,
    nodeExecutionResult: NodeExecutionResult | undefined,
  ): ApplyWorkflowNodePayload {
    const { nodeInput, workflow, workflowNode } = nodePayload;
    if (!workflowNode) {
      throw new Error('workflowNode missing'); /* sanity check */
    }

    const requestedNextNodeId = nodeExecutionResult
      ? nodeExecutionResult.requestedNextNodeId
      : workflowNode?.nextNodeId;

    const result = nodeExecutionResult ? nodeExecutionResult.result : nodeInput;
    const resultSchema = nodeExecutionResult ? nodeExecutionResult.resultSchema : nodeInput?.schema;

    const nextNode = getWorkflowNodeById(requestedNextNodeId, workflow);
    assertNextNodeIsNotSelf(workflowNode, nextNode);

    const nextNodePayload: ApplyWorkflowNodePayload = {
      ...nodePayload,
      nodeInput: result,
      schema: resultSchema,
      prevNodeId: workflowNode.id,
      workflowNode: nextNode,
    };
    return nextNodePayload;
  }
}
